var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.706,
    height: 17.706,
    viewBox: "0 0 17.706 17.706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-local-phone",
    "data-name": "Icon material-local-phone",
    d: "M8.061,12.163a14.9,14.9,0,0,0,6.482,6.482l2.164-2.164a.978.978,0,0,1,1-.236,11.221,11.221,0,0,0,3.512.561.987.987,0,0,1,.984.984v3.433a.987.987,0,0,1-.984.984A16.721,16.721,0,0,1,4.5,5.484.987.987,0,0,1,5.484,4.5H8.927a.987.987,0,0,1,.984.984A11.175,11.175,0,0,0,10.471,9a.987.987,0,0,1-.246,1Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#8faa44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.daaf4b06274297c3801674b22b2eee18.svg";
export { ForwardRef as ReactComponent };